"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8358],{

/***/ 18796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "t": function() { return /* binding */ thoundsandDelimiter; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68166);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31310);






function thoundsandDelimiter(number) {
    if (!number) {
        return '0';
    }
    return number
        .toLocaleString('de-DE', { maximumFractionDigits: 2 })
        .toString();
}
const StyledCurrency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span `
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  width: max-content;
  display: inline-block;
`;
const Text = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(({ underline }) => _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    text-decoration: ${underline ? 'underline' : ''};
  `);
const Currency = (_a) => {
    var { value, hideCurrency = false, space = false, underline = false } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(_a, ["value", "hideCurrency", "space", "underline"]);
    if (!value && value !== 0) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, Object.assign({}, props), "\u00A0");
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, Object.assign({}, props),
        thoundsandDelimiter(value),
        !hideCurrency && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            space && ' ',
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, { underline: underline }, "\u0111")))));
};




/***/ }),

/***/ 11005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "XE": function() { return /* binding */ floorPercentage; },
/* harmony export */   "e9": function() { return /* binding */ percentage; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67085);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55151);
/* harmony import */ var _constant_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59980);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68166);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31310);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59802);









function parseFlex(flex) {
    if (typeof flex === 'number') {
        return `${flex} ${flex} auto`;
    }
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
        return `0 0 ${flex}`;
    }
    return flex;
}
const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const Col = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const { gutter, wrap } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    const { span, order, offset, push, pull, className, children, flex, style } = props, others = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(props, ["span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
    const prefixCls = 'teko-col';
    let sizeClassObj = {};
    sizes.forEach((size) => {
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') {
            sizeProps.span = propSize;
        }
        else if (typeof propSize === 'object') {
            sizeProps = propSize || {};
        }
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), { [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined, [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0, [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0, [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0, [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0 });
    });
    const classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull,
    }, className, sizeClassObj);
    let mergedStyle = Object.assign({}, style);
    if (gutter) {
        mergedStyle = Object.assign(Object.assign({}, (gutter[0] && gutter[0] > 0
            ? {
                paddingLeft: gutter[0] / 2,
                paddingRight: gutter[0] / 2,
            }
            : {})), mergedStyle);
    }
    if (flex) {
        mergedStyle.flex = parseFlex(flex);
        if (flex === 'auto' && wrap === false && !mergedStyle.minWidth) {
            mergedStyle.minWidth = 0;
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, Object.assign({}, others, { style: mergedStyle, className: classes, ref: ref }), children));
});
Col.displayName = 'Col';
const floorPercentage = (percent) => {
    return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
    return floorPercentage((x / y) * 100) + '%';
};
const loopGridColumn = (_class = '') => {
    let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
    for (let i = 1; i <= 24; i++) {
        _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
        max-width: ${_class === '-lg'
            ? '84px'
            : ['-xl', '-xxl'].includes(_class)
                ? '104px'
                : percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
    }
    return _css;
};
const makeGrid = _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv `
  ${loopGridColumn()}
  ${loopGridColumn('-xs')}
  ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d)
    .map((label) => label !== 'xs'
    ? `
    @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  `
    : '')
    .join('')}
`;
const flexStyle = (flex) => {
    if (!flex)
        return;
    return `
    flex: ${parseFlex(flex)};
    ${typeof flex === 'string' ? `max-width: ${flex} !important;` : ''}
  `;
};
const makeFlexStyles = (props) => {
    var _a;
    return _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv `
    ${typeof props.xs === 'object' && ((_a = props.xs) === null || _a === void 0 ? void 0 : _a.flex) !== undefined
        ? flexStyle(props.xs.flex)
        : ''}
    ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d)
        .map((label) => {
        var _a, _b;
        return ((_a = props[label]) === null || _a === void 0 ? void 0 : _a.flex) && label !== 'xs'
            ? `
      @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d[label]}) {
        ${flexStyle((_b = props[label]) === null || _b === void 0 ? void 0 : _b.flex)};
      }
    `
            : '';
    })
        .join('')}
  `;
};
const StyledCol = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(`
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__/* .CommonStyles */ .F, makeGrid, makeFlexStyles);




/***/ }),

/***/ 51296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.1-f2ae0a8d3c-14db8889d5.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(67085);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/RowContext.es.js
var RowContext_es = __webpack_require__(55151);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/util.es.js
const responsiveArray = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs',
];
const responsiveMap = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1440px)',
    xxl: '(min-width: 1600px)',
};
const subscribers = new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
    matchHandlers: {},
    dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach((func) => func(screens));
        return subscribers.size >= 1;
    },
    subscribe(func) {
        if (!subscribers.size)
            this.register();
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
    },
    unsubscribe(token) {
        subscribers.delete(token);
        if (!subscribers.size)
            this.unregister();
    },
    unregister() {
        Object.keys(responsiveMap).forEach((screen) => {
            const matchMediaQuery = responsiveMap[screen];
            const handler = this.matchHandlers[matchMediaQuery];
            handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
    },
    register() {
        Object.keys(responsiveMap).forEach((screen) => {
            const matchMediaQuery = responsiveMap[screen];
            const listener = ({ matches }) => {
                this.dispatch(Object.assign(Object.assign({}, screens), { [screen]: matches }));
            };
            const mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            this.matchHandlers[matchMediaQuery] = {
                mql,
                listener,
            };
            listener(mql);
        });
    },
};
var ResponsiveObserve = responsiveObserve;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/constant.es.js
var constant_es = __webpack_require__(59980);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(68166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/Row.es.js









const Row = react.forwardRef((props, ref) => {
    const { justify, align, className, style, children, gutter = 0, wrap } = props, others = (0,tslib_es6/* __rest */._T)(props, ["justify", "align", "className", "style", "children", "gutter", "wrap"]);
    const [screens, setScreens] = react.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
    });
    const gutterRef = react.useRef(gutter);
    react.useEffect(() => {
        const token = ResponsiveObserve.subscribe((screen) => {
            const currentGutter = gutterRef.current || 0;
            if ((!Array.isArray(currentGutter) &&
                typeof currentGutter === 'object') ||
                (Array.isArray(currentGutter) &&
                    (typeof currentGutter[0] === 'object' ||
                        typeof currentGutter[1] === 'object'))) {
                setScreens(screen);
            }
        });
        return () => ResponsiveObserve.unsubscribe(token);
    }, []);
    const getGutter = () => {
        const results = [0, 0];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach((g, index) => {
            if (typeof g === 'object') {
                for (let i = 0; i < responsiveArray.length; i++) {
                    const breakpoint = responsiveArray[i];
                    if (screens[breakpoint] && g[breakpoint] !== undefined) {
                        results[index] = g[breakpoint];
                        break;
                    }
                }
            }
            else {
                results[index] = g || 0;
            }
        });
        return results;
    };
    const prefixCls = 'teko-row';
    const gutters = getGutter();
    const classes = classnames_default()(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${justify}`]: justify,
        [`${prefixCls}-${align}`]: align,
    }, className);
    const rowStyle = Object.assign(Object.assign(Object.assign({}, (gutters[0] && gutters[0] > 0
        ? {
            marginLeft: gutters[0] / -2,
            marginRight: gutters[0] / -2,
        }
        : {})), (gutters[1] && gutter[1] > 0
        ? {
            rowGap: gutters[1],
        }
        : {})), style);
    return (react.createElement(RowContext_es/* default.Provider */.Z.Provider, { value: { gutter: gutters, wrap } },
        react.createElement(StyledRow, Object.assign({}, others, { className: classes, style: rowStyle, ref: ref }), children)));
});
Row.displayName = 'Row';
const StyledRow = emotion_styled_browser_esm/* default.div */.Z.div `
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${constant_es/* BREAK_POINTS.lg */.d.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
  ${index_es/* CommonStyles */.F}
`;




/***/ }),

/***/ 55151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RowContext$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var RowContext$1 = RowContext;




/***/ }),

/***/ 59980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BREAK_POINTS; },
/* harmony export */   "s": function() { return /* binding */ GRID_COLUMNS; }
/* harmony export */ });
const BREAK_POINTS = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1440px',
    xxl: '1600px',
};
const GRID_COLUMNS = 12;




/***/ }),

/***/ 38903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95520);





const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + 'px'};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
    var { height, isLoading, hideLogo = false, logo } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["height", "isLoading", "hideLogo", "logo"]);
    if (!isLoading)
        return null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props, { height: height }), !hideLogo && react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, { logo: logo })));
};




/***/ }),

/***/ 64802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16251);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59802);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57578);




const ProductPrice = ({ supplierRetailPrice, latestPrice, discountPercent, textColor = 'primary500', align = 'start', size = 'm', className, priceRange, }) => {
    const formattedRetailPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(supplierRetailPrice);
    const formattedLatestPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(latestPrice);
    let renderedRetailPrice, renderedDiscount;
    const renderedLatestPrice = () => {
        if (!priceRange) {
            return size === 'l' ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, Object.assign({ level: 2, color: textColor, weight: "bold" }, { children: formattedLatestPrice }), void 0)) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, Object.assign({ level: 1, color: textColor }, { children: formattedLatestPrice }), void 0));
        }
        const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(priceRange.min, false);
        const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .x)(priceRange.max);
        return size === 'l' ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledTitle, Object.assign({ level: 2, color: textColor, weight: "bold", line: 1 }, { children: [formattedMinPrice, " - ", formattedMaxPrice] }), void 0)) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSubTitle, Object.assign({ level: 1, color: textColor, line: 1 }, { children: [formattedMinPrice, " - ", formattedMaxPrice] }), void 0));
    };
    switch (size) {
        case 'l':
            renderedRetailPrice = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledRetailPrice, Object.assign({ level: 1, color: "textSecondary" }, { children: formattedRetailPrice }), void 0));
            renderedDiscount = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, Object.assign({ level: 1, color: textColor }, { children: discountPercent }), void 0));
            break;
        default:
            renderedRetailPrice = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledRetailPrice, Object.assign({ level: 1, color: "textSecondary" }, { children: formattedRetailPrice }), void 0));
            renderedDiscount = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, Object.assign({ level: 1, color: textColor }, { children: discountPercent }), void 0));
            break;
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ProductPriceWrapper, Object.assign({ align: align, className: className }, { children: [renderedLatestPrice(), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledDiscount, { children: [supplierRetailPrice &&
                        supplierRetailPrice > latestPrice &&
                        renderedRetailPrice, !!discountPercent && renderedDiscount] }, void 0)] }), void 0));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div `
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx) `
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK) `
  word-break: break-all;
`;




/***/ }),

/***/ 57578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
const formatCurrency = (value, includeUnit = true) => {
    if (typeof value !== 'number')
        return null;
    let currencyFormat;
    if (includeUnit)
        currencyFormat = new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND',
        });
    else
        currencyFormat = new Intl.NumberFormat('vi-VN');
    return currencyFormat.format(value);
};




/***/ }),

/***/ 53318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ ContainerLoading; },
  "gb": function() { return /* binding */ Loading; },
  "b7": function() { return /* binding */ PreLoad; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(38903);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(43476);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(95889);
;// CONCATENATED MODULE: ./components/LogoLoading.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Wrapper = styled_es/* styled.div */.z.div(_templateObject());
var Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)(_templateObject1());
var Spinner = styled_es/* styled.div */.z.div(function(param) {
    var theme = param.theme;
    return "\n    background: none;\n    @keyframes ldio-yuapljtmof {\n      0% {\n        transform: rotate(0deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .ldio-yuapljtmof  {\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      animation: ldio-yuapljtmof 1s linear infinite;\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      box-shadow: 0 2px 0 0 ".concat(theme.brand.loading || '#1435c3', ";\n      box-sizing: content-box;\n    }\n");
});
var LogoLoading = function(_param) {
    var _logo = _param.logo, logo = _logo === void 0 ? '' : _logo, props = _objectWithoutProperties(_param, [
        "logo"
    ]);
    var size = 80;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpread({}, props, {
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                width: size / 2,
                height: size / 2,
                src: logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ldio-yuapljtmof"
                })
            })
        ]
    })));
};


;// CONCATENATED MODULE: ./components/Loading.tsx






function Loading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Loading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Loading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Loading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Loading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Loading_templateObject() {
    var data = Loading_taggedTemplateLiteral([
        "\n  background: #fff2;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n"
    ]);
    Loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loading_templateObject1() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    Loading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n  transition: opacity 0.3s;\n  &.loading-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Loading_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledOverlay = styled_es/* styled.div */.z.div(Loading_templateObject());
var Loading = function(param) {
    var isLoading = param.isLoading, children = param.children;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            })
        ]
    }));
};
var PreLoad = function(_param) {
    var isLoading = _param.isLoading, props = Loading_objectWithoutProperties(_param, [
        "isLoading"
    ]);
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PreLoad_es/* PreLoad */.b, Loading_objectSpread({}, props, {
        isLoading: isLoading,
        logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
    })));
};

var ContainerLoadingWrapper = styled_es/* styled.div */.z.div(Loading_templateObject1());
var Container = styled_es/* styled.div */.z.div(_templateObject2());
var LoadingContainer = styled_es/* styled.div */.z.div(_templateObject3());
var ContainerLoading = function(param) {
    var children = param.children, style = param.style, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerLoadingWrapper, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: isLoading ? 'loading-blur' : '',
                children: children
            })
        ]
    }));
};


/***/ }),

/***/ 39568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85172);
/* harmony import */ var _terra_js_payment_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25098);
/* harmony import */ var _terra_js_payment_kit_dist_constansts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91621);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47360);
/* harmony import */ var _terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22765);
/* harmony import */ var _terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5__);






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var waitForPaymentStatus = 'WAITING_FOR_PAYMENT_CONFIRMATION';
var terraHelper = {
    isAvailable: _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable,
    handleBackOr: function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(callback) {
            var shouldHandleBack;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 3;
                        return _terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5___default().shouldHandleBack();
                    case 3:
                        shouldHandleBack = _ctx.sent;
                        if (shouldHandleBack) {
                            _terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5___default().handleBack();
                        } else {
                            callback === null || callback === void 0 ? void 0 : callback();
                        }
                        _ctx.next = 8;
                        break;
                    case 7:
                        {
                            callback();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(callback) {
            return _ref.apply(this, arguments);
        };
    }(),
    getScreenConfig: function() {
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) {
            return _terra_js_shop_front_kit__WEBPACK_IMPORTED_MODULE_5___default().getScreenConfig();
        } else {
            return Promise.resolve(undefined);
        }
    },
    finish: function() {
        return _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].finish */ .Z.finish();
    },
    payForOrder: function(param) {
        var order = param.order, customerProfileId = param.customerProfileId, orderService = param.orderService;
        return terraHelper.pay({
            orderCode: order.code,
            orderId: order.id,
            amount: order.remainPayment,
            customerProfileId: customerProfileId,
            orderService: orderService
        });
    },
    pay: function(param) {
        var orderCode = param.orderCode, orderId = param.orderId, amount = param.amount, customerProfileId = param.customerProfileId, orderService = param.orderService;
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) {
            var paymentRequestBuilder = new _terra_js_payment_kit__WEBPACK_IMPORTED_MODULE_2__/* .PaymentRequestBuilder */ .hb();
            paymentRequestBuilder.setOrder({
                orderCode: orderCode,
                orderAmount: amount
            }).setPaymentMethods({
                mainMethod: {
                    method: _terra_js_payment_kit_dist_constansts__WEBPACK_IMPORTED_MODULE_3__.MainMethodType.All,
                    amount: amount
                },
                totalAmount: amount
            }).setOptions({
                shouldShowPaymentResultScreen: true
            });
            return _terra_js_payment_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].payForOrder */ .ZP.payForOrder(paymentRequestBuilder.build()).then(function(result) {
                switch(result.resultCode){
                    case 'succeeded':
                        window.location.href = "/account/orders/".concat(orderId);
                        break;
                    case 'canceled':
                    case 'failed':
                        orderService.getOrder({
                            orderId: orderId,
                            customerId: customerProfileId
                        }).then(function(order) {
                            if (order.status === waitForPaymentStatus) {
                                window.location.href = "/confirm-payment/".concat(orderId);
                            } else {
                                window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                            }
                        }).catch(function() {
                            // this is a fallback in case the order is not synced with cov
                            window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                        });
                        break;
                }
            });
        }
        return Promise.resolve();
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (terraHelper);


/***/ }),

/***/ 62546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ usePaymentMethods; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43476);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12354);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84982);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47248);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var helpers_terra__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39568);
/* harmony import */ var _teko_payment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10957);







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var usePaymentMethods = function(orderDetail) {
    var ref = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)(), terminal = ref.terminal, channel = ref.channel, baseDomain = ref.baseDomain, isMobile = ref.isMobile;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,_contexts__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)(), cartService = ref2.cartService, paymentService = ref2.paymentService;
    var defaultParamsCart = {
        terminal: terminal,
        channel: channel
    };
    var ref3 = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)(), loadingIAMProfile = ref3.loading, myProfile = ref3.user;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), paymentMethods = ref4[0], setPaymentMethods = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), paymentDeposit = ref5[0], setPaymentDeposit = ref5[1];
    var paymentType = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalData */ .U5)().paymentType;
    var resetPaymentMethods = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!loadingIAMProfile && (paymentType === 'normal' || paymentType === 'terra' && !helpers_terra__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isAvailable */ .Z.isAvailable())) cartService.getPaymentMethod(defaultParamsCart, (orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.originalCode) || (orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.code) || null).then(function(param) {
            var res = param.paymentMethods, merchantCode = param.merchantCode, deposit = param.deposit;
            if (res) {
                var methods = res.map(function(method) {
                    return _objectSpread({}, method, {
                        merchantCode: merchantCode
                    });
                });
                // move VNPAY_GATEWAY first
                var idxVnpayGateway = methods.findIndex(function(el) {
                    return el.methodCode === _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodCode.VNPAY_GATEWAY */ .K$.VNPAY_GATEWAY;
                });
                if (idxVnpayGateway >= 1) {
                    var temp = methods[idxVnpayGateway];
                    methods[idxVnpayGateway] = methods[0];
                    methods[0] = temp;
                }
                var applicableMethods = isMobile ? methods.filter(// installment is currently unavailable on mobile
                function(item) {
                    return ![
                        _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodGroupCode.INSTALLMENT */ .kJ.INSTALLMENT
                    ].includes(item.methodGroupCode.toUpperCase());
                }) : methods;
                setPaymentMethods((deposit === null || deposit === void 0 ? void 0 : deposit.allowDeposit) ? applicableMethods.filter(function(method) {
                    return method.methodGroupCode.toUpperCase() !== _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodGroupCode.CREDIT */ .kJ.CREDIT && method.methodCode !== _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodCode.COD */ .K$.COD && method.methodCode !== _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodCode.COD_OFFLINE */ .K$.COD_OFFLINE;
                }) : applicableMethods);
                setPaymentDeposit(_objectSpread({}, deposit, {
                    method: methods.find(function(method) {
                        return method.methodCode === _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodCode.COD */ .K$.COD;
                    })
                }));
            }
        }).finally(function() {
            return setLoading(false);
        });
    }, [
        terminal,
        loadingIAMProfile,
        JSON.stringify(orderDetail)
    ]);
    var onAddVnpayToken = function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cardType) {
            var vnpayTokenMethods, merchantMethodCode, res;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        vnpayTokenMethods = paymentMethods.filter(function(el) {
                            return el.methodCode === _teko_payment__WEBPACK_IMPORTED_MODULE_7__/* .PaymentMethodCode.VNPAY_TOKEN */ .K$.VNPAY_TOKEN;
                        });
                        merchantMethodCode = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(vnpayTokenMethods, '0.merchantMethodCode');
                        if (!merchantMethodCode) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 5;
                        return paymentService.requestCreateToken(merchantMethodCode, myProfile === null || myProfile === void 0 ? void 0 : myProfile.userId, cardType, "".concat(baseDomain, "/checkout"), "".concat(baseDomain, "/checkout"));
                    case 5:
                        res = _ctx.sent;
                        if (res && res.returnUrl) {
                            window.location.href = res.returnUrl;
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onAddVnpayToken(cardType) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        paymentMethods: paymentMethods,
        resetPaymentMethods: resetPaymentMethods,
        onAddVnpayToken: onAddVnpayToken,
        paymentDeposit: paymentDeposit,
        loading: loading
    };
};


/***/ }),

/***/ 58555:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PaymentKit = void 0;
var common_1 = __webpack_require__(38971);
var constansts_1 = __webpack_require__(91621);
var PaymentKit = /** @class */ (function () {
    function PaymentKit() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('PaymentKitModule');
    }
    /**
     * @deprecated Should use payForOrder method instead
     */
    PaymentKit.prototype.pay = function (paymentRequest) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule.invoke('pay', paymentRequest).then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    PaymentKit.prototype.payForOrder = function (paymentRequest, appName) {
        var _this = this;
        if (appName === void 0) { appName = null; }
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke('payForOrder', { appName: appName, paymentRequest: paymentRequest })
                .then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                code: constansts_1.UnknownExceptionCode,
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            code: constansts_1.UnknownExceptionCode,
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    PaymentKit.prototype.payForOrderLegacy = function (paymentRequest, appName) {
        var _this = this;
        if (appName === void 0) { appName = null; }
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke('payForOrderLegacy', { appName: appName, paymentRequest: paymentRequest })
                .then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                code: constansts_1.UnknownExceptionCode,
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            code: constansts_1.UnknownExceptionCode,
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    return PaymentKit;
}());
exports.PaymentKit = PaymentKit;


/***/ }),

/***/ 90964:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PaymentRequestBuilder = void 0;
var PaymentRequestBuilder = /** @class */ (function () {
    function PaymentRequestBuilder() {
    }
    PaymentRequestBuilder.prototype.setOrder = function (order) {
        this.order = order;
        return this;
    };
    PaymentRequestBuilder.prototype.setPaymentMethods = function (paymentMethods) {
        this.paymentMethods = paymentMethods;
        return this;
    };
    PaymentRequestBuilder.prototype.setMetadata = function (metadata) {
        this.metadata = metadata;
        return this;
    };
    PaymentRequestBuilder.prototype.setClientConfig = function (clientConfig) {
        this.clientConfig = clientConfig;
        return this;
    };
    PaymentRequestBuilder.prototype.setOptions = function (options) {
        this.options = options;
        return this;
    };
    PaymentRequestBuilder.prototype.build = function () {
        return {
            order: this.order,
            paymentWith: this.paymentMethods,
            metadata: this.metadata,
            clientConfig: this.clientConfig,
            options: this.options,
        };
    };
    return PaymentRequestBuilder;
}());
exports.PaymentRequestBuilder = PaymentRequestBuilder;


/***/ }),

/***/ 91621:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UnknownExceptionMessage = exports.UnknownExceptionCode = exports.MainMethodType = exports.ResultCode = void 0;
var ResultCode;
(function (ResultCode) {
    ResultCode["Succeeded"] = "succeeded";
    ResultCode["Failed"] = "failed";
    ResultCode["Canceled"] = "canceled";
})(ResultCode = exports.ResultCode || (exports.ResultCode = {}));
var MainMethodType;
(function (MainMethodType) {
    MainMethodType["VNPayGatewayQR"] = "VNPayGatewayQR";
    MainMethodType["COD"] = "COD";
    MainMethodType["QRCodeMMS"] = "QRCodeMMS";
    MainMethodType["SPOSCard"] = "SPOSCard";
    MainMethodType["EWallet"] = "EWallet";
    MainMethodType["QRCodeCustomer"] = "QRCodeCustomer";
    MainMethodType["MoMoAIO"] = "MoMoAIO";
    MainMethodType["Cash"] = "Cash";
    MainMethodType["BankTransfer"] = "BankTransfer";
    MainMethodType["Installment"] = "Installment";
    MainMethodType["All"] = "All";
    MainMethodType["MoMoQROffline"] = "MoMoQROffline";
    MainMethodType["VNPayGatewayCreditCard"] = "VNPayGatewayCreditCard";
    MainMethodType["VNPayGatewayATMBank"] = "VNPayGatewayATMBank";
    MainMethodType["VNPayGatewayMobileBanking"] = "VNPayGatewayMobileBanking";
})(MainMethodType = exports.MainMethodType || (exports.MainMethodType = {}));
exports.UnknownExceptionCode = 'UnknownException';
exports.UnknownExceptionMessage = 'Unexpected error occurred!';


/***/ }),

/***/ 25098:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.hb = void 0;
var PaymentKit_1 = __webpack_require__(58555);
var PaymentRequestBuilder_1 = __webpack_require__(90964);
Object.defineProperty(exports, "hb", ({ enumerable: true, get: function () { return PaymentRequestBuilder_1.PaymentRequestBuilder; } }));
var paymentKit = new PaymentKit_1.PaymentKit();
__webpack_require__.g['paymentKit'] = paymentKit;
exports.ZP = paymentKit;


/***/ }),

/***/ 42136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopFrontKit = void 0;
var common_1 = __webpack_require__(38971);
var ShopFrontKit = /** @class */ (function () {
    function ShopFrontKit() {
        this.GET_SCREEN_CONFIG_COMMAND = 'getScreenConfig';
        this.SHOULD_HANDLE_BACK_COMMAND = 'shouldHandleBack';
        this.HANDLE_BACK_COMMAND = 'handleBack';
        this.wrappedModule = null;
        this.shouldLog = false;
        this.wrappedModule = new common_1.ModuleWrapper('ShopFrontKitModule');
    }
    ShopFrontKit.prototype.setLogging = function (enable) {
        this.shouldLog = enable;
    };
    ShopFrontKit.prototype.log = function (message, obj) {
        if (this.shouldLog) {
            console.log("[ShopFrontKitModule] " + message + " " + JSON.stringify(obj));
        }
    };
    ShopFrontKit.prototype.shouldHandleBack = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke(_this.SHOULD_HANDLE_BACK_COMMAND)
                .then(function (response) {
                _this.log(_this.SHOULD_HANDLE_BACK_COMMAND, response);
                if (response.status_code == 200) {
                    resolve(response.result.shouldHandleBack);
                }
                else {
                    resolve(false);
                }
            });
        });
    };
    ShopFrontKit.prototype.handleBack = function () {
        this.wrappedModule.invoke(this.HANDLE_BACK_COMMAND).then();
    };
    ShopFrontKit.prototype.getScreenConfig = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke(_this.GET_SCREEN_CONFIG_COMMAND, { screen: window.location.pathname })
                .then(function (response) {
                _this.log(_this.GET_SCREEN_CONFIG_COMMAND, response);
                if (response.status_code == 200) {
                    resolve(response.result);
                }
                else {
                    resolve(undefined);
                }
            });
        });
    };
    return ShopFrontKit;
}());
exports.ShopFrontKit = ShopFrontKit;


/***/ }),

/***/ 22765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var ShopFrontKit_1 = __webpack_require__(42136);
var shopFrontKit = new ShopFrontKit_1.ShopFrontKit();
__webpack_require__.g['shopFrontKit'] = shopFrontKit;
exports["default"] = shopFrontKit;
__exportStar(__webpack_require__(21806), exports);


/***/ }),

/***/ 21806:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ })

}]);